export default "__VITE_ASSET__37ef088d__"